import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Pulse',
  props: {
    color: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  color?: string
  size?: number
}



const { color = "var(--primaryperalta-red-100)", size = 15 } = props

return { __sfc: true,props, color, size }
}

})